module.exports = __webpack_public_path__ + "static/img/11.78739c40.png";